// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__s9QN3","head":"Table_head__Ahq2g","row":"Table_row__2mDSS","cell":"Table_cell__3_1Hr","round":"Table_round__3i9QD","th":"Table_th__1iKFM"};